<template>
  <div>
    <h3 class="mb-4">Lacak Serial Number</h3>

    <p class="text-sm text-gray-600 mb-2">
      Masukkan SN (Pack ID), bisa lebih dari satu dipisah enter, koma, atau spasi. Maksimal 1000 SN.
    </p>
    <vs-textarea
      v-model="snInput"
      label="Serial Number"
      height="140px"
      class="w-full mb-2"
    />
    <p class="text-sm text-gray-600 mb-4">{{ snList.length }} SN</p>

    <div class="flex flex-wrap items-center mb-4">
      <vs-button
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-search"
        class="mr-2 mb-2"
        :disabled="snList.length === 0 || isLoading"
        @click="search"
      >
        Lacak
      </vs-button>
      <vs-button
        color="success"
        type="filled"
        icon-pack="feather"
        icon="icon-download"
        class="mr-2 mb-2"
        :disabled="rows.length === 0 || isLoading"
        @click="exportExcel"
      >
        Export Excel
      </vs-button>
      <vs-button
        color="dark"
        type="border"
        class="mb-2"
        :disabled="isLoading"
        @click="reset"
      >
        Reset
      </vs-button>
    </div>

    <div v-if="isLoading" class="text-center py-8">Loading...</div>

    <template v-if="!isLoading && searched">
      <vs-alert v-if="notFound.length > 0" color="warning" active="true" class="mb-4 lacak-sn-alert">
        {{ notFound.length }} SN tidak ditemukan: {{ notFound.join(", ") }}
      </vs-alert>

      <div v-if="rows.length === 0" class="text-center py-8">
        Tidak ada transaksi ditemukan.
      </div>

      <vs-table v-else :data="paginatedData">
        <template slot="thead">
          <vs-th>No.</vs-th>
          <vs-th>Pack ID</vs-th>
          <vs-th>Warehouse ID</vs-th>
          <vs-th>Warehouse Name</vs-th>
          <vs-th>Transaction Type</vs-th>
          <vs-th>Reference</vs-th>
          <vs-th>Posting Date</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tr v-for="(row, index) in data" :key="index">
            <vs-td>{{ dataFrom + index }}</vs-td>
            <vs-td>{{ row.pack_id }}</vs-td>
            <vs-td>{{ row.warehouse_id }}</vs-td>
            <vs-td>{{ row.warehouse_name }}</vs-td>
            <vs-td>{{ row.transaction_type }}</vs-td>
            <vs-td>{{ row.reference }}</vs-td>
            <vs-td>{{ row.posting_date }}</vs-td>
          </tr>
        </template>
      </vs-table>

      <div v-if="rows.length > 0" class="flex justify-end items-center mt-4">
        <p class="mr-4 mb-0">
          <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ rows.length }} transaksi</b>
          (dari {{ totalSn }} SN)
        </p>
        <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
      </div>
    </template>
  </div>
</template>

<script>
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      isLoading: false,
      searched: false,
      snInput: "",
      searchedSn: [],
      rows: [],
      notFound: [],
      totalSn: 0,
      currentPage: 1,
      perPage: 10,
    };
  },
  computed: {
    snList() {
      const list = this.snInput.split(/[\s,;]+/).filter((sn) => sn !== "");
      return [...new Set(list)];
    },
    totalPage() {
      return Math.ceil(this.rows.length / this.perPage);
    },
    dataFrom() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    dataTo() {
      return Math.min(this.currentPage * this.perPage, this.rows.length);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.rows.slice(start, start + this.perPage);
    },
  },
  methods: {
    search() {
      this.isLoading = true;
      const sn = this.snList;
      this.$http
        .post("support/lacak-sn", { sn })
        .then((res) => {
          this.searchedSn = sn;
          this.rows = res.data.data || [];
          this.notFound = res.data.not_found || [];
          this.totalSn = res.data.total_sn || 0;
          this.currentPage = 1;
          this.searched = true;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$emit("error", error);
        });
    },
    exportExcel() {
      this.isLoading = true;
      // export pakai SN dari pencarian terakhir supaya sama dengan tabel
      this.$http
        .post("support/lacak-sn/export-excel", { sn: this.searchedSn }, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          this.isLoading = false;
          saveAs(blob, `lacak_sn_${Date.now()}.xlsx`);
        })
        .catch((error) => {
          this.isLoading = false;
          this.$emit("error", error);
        });
    },
    reset() {
      this.snInput = "";
      this.searchedSn = [];
      this.rows = [];
      this.notFound = [];
      this.totalSn = 0;
      this.currentPage = 1;
      this.searched = false;
    },
  },
};
</script>

<style scoped>
.lacak-sn-alert {
  height: auto !important;
  word-break: break-all;
}
</style>
